export enum FormFieldTypes {
  INPUT_TEXT_FIELD,
  INPUT_MULTI_LINE_TEXT_FIELD,
  INPUT_NUMBER_FIELD,
  INPUT_SELECT_FIELD,
  INPUT_DATE_FIELD,
  FILE_UPLOAD_BUTTON,
  FORM_SECTION_TITLE,
}
